import { types } from '../actions/types';

export const userReducer = (state = { token: null, status: null, message: null, createClient: null, clientList: null, notify: null }, action) => {
    switch (action.type) {
        case types.userCreate:
            return {
              ...state,
              token: action.payload.token,
              status: action.payload.status,
              message: action.payload.message,
            };
        case types.userUpdate:
          return {
            ...state,
            token: action.payload.token,
            status: action.payload.status,
            message: action.payload.message,
          };
        case types.userList:
            return {
              ...state,
              token: action.payload.token,
              status: action.payload.status,
              message: action.payload.message,
              data: action.payload.data
            };
        case types.roles:
              return {
                ...state,
                roles : action.payload.roles,
                status: action.payload.status,
                message: action.payload.message
                
              };
        case types.deleteUser:
                return {
                  ...state,
                  roles : action.payload.roles,
                  status: action.payload.status,
                  message: action.payload.message
                  
                };
        case types.createClient:
          return {
            ...state,
            createClient: {
              data : action.payload.data,
              status: action.payload.status,
              message: action.payload.message
            }
          };
        case types.clientUpdate:
          return {
            ...state,
            clientUpdate: {
              data : action.payload.data,
              status: action.payload.status,
              message: action.payload.message
            }
          };
        case types.notify:
            return {
              ...state,
              notify: {
                data : action.payload.data,
                status: action.payload.status,
                message: action.payload.message
              }
            };
        case types.clientList:
          return {
            ...state,
            clientList: {
              data : action.payload.data,
              status: action.payload.status,
              message: action.payload.message
            }

          };
        case types.roleCreate:
          return {
            ...state,
            roleAction: {
              type: 'create',
              status: action.payload.status,
              message: action.payload.message,
              role: action.payload.role,
            }
          };
        case types.roleUpdate:
          return {
            ...state,
            roleAction: {
              type: 'update',
              status: action.payload.status,
              message: action.payload.message,
            }
          };
        case types.roleDelete:
          return {
            ...state,
            roleAction: {
              type: 'delete',
              status: action.payload.status,
              message: action.payload.message,
            }
          };
        case types.permissionRegistry:
          return {
            ...state,
            permissionRegistry: action.payload.registry,
            permissionRegistryError: action.payload.error || null,
          };
        default:
            return state;
    }
}